import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AllRecipesPage from './pages/AllRecipesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import SingleRecipePage from './pages/SingleRecipePage';
import SeriesPage from './pages/SeriesPage';
import Sidebar from './components/Sidebar';

function App() {
  return (
    <Router>
      <Sidebar />
      <div style={{ padding: "1rem", marginLeft: "200px" }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/recipes" element={<AllRecipesPage />} />
          <Route path="/recipes/:id" element={<SingleRecipePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/series/:seriesName" element={<SeriesPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
